/**
 * Content-Card-Store
 *
 * Geteilter Speicher für die von Braze gelieferten Content Cards.
 * `index.js` füttert den Store nach openSession via requestContentCardsRefresh
 * (Success-Callback + getCachedContentCards), das <braze-content-card>-Element liest
 * die Cards über whenReady().
 *
 * WICHTIG: Producer (`index.js`) und Consumer (Element) liegen in VERSCHIEDENEN Bundles
 * (shell.js bzw. braze.js). Der State darf daher nicht im Modul-Scope liegen — sonst
 * hätte jedes Bundle eine eigene, getrennte Kopie. Deshalb liegt der State auf einem
 * window-Global, das sich beide Bundle-Kopien des Moduls teilen.
 */
const STATE_KEY = '__brazeContentCardStore';

function getState() {
	let state = window[STATE_KEY];
	if (!state) {
		let resolveReady;
		const readyPromise = new Promise((resolve) => { resolveReady = resolve; });
		state = window[STATE_KEY] = { currentCards: null, resolveReady, readyPromise };
	}
	return state;
}

/**
 * @param {object[]} cards - Braze Content Cards
 */
export function setCards(cards) {
	const state = getState();
	state.currentCards = cards;
	state.resolveReady(cards); // löst beim ersten Mal auf; spätere Aufrufe sind No-ops
}

/**
 * @returns {Promise<object[]>} löst auf, sobald die ersten Cards vorliegen
 */
export function whenReady() {
	const state = getState();
	// Hinweis: ein leeres Cards-Array ([]) ist truthy -> Late-Joiner bekommen auch
	// "keine Cards vorhanden" sofort, das Element bleibt dann korrekt leer.
	return state.currentCards ? Promise.resolve(state.currentCards) : state.readyPromise;
}

export function _resetForTesting() {
	delete window[STATE_KEY];
}
